import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  "aria-hidden": "true",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.929 1.929v6.428h3.857V1.93zM0 1.929A1.93 1.93 0 0 1 1.929 0h3.857a1.93 1.93 0 0 1 1.928 1.929v6.428a1.93 1.93 0 0 1-1.928 1.929H1.929A1.93 1.93 0 0 1 0 8.357zm12.214 7.714v6.428h3.857V9.643zm-1.928 0a1.93 1.93 0 0 1 1.928-1.929h3.857A1.93 1.93 0 0 1 18 9.643v6.428A1.93 1.93 0 0 1 16.071 18h-3.857a1.93 1.93 0 0 1-1.928-1.929zm-4.5 3.857H1.929v2.571h3.857zm-3.857-1.929h3.857A1.93 1.93 0 0 1 7.714 13.5v2.571A1.93 1.93 0 0 1 5.786 18H1.929A1.93 1.93 0 0 1 0 16.071V13.5a1.93 1.93 0 0 1 1.929-1.929M12.214 1.93V4.5h3.857V1.929zm-1.928 0A1.93 1.93 0 0 1 12.214 0h3.857A1.93 1.93 0 0 1 18 1.929V4.5a1.93 1.93 0 0 1-1.929 1.929h-3.857A1.93 1.93 0 0 1 10.286 4.5z" }, null, -1)
  ])))
}
export default { render: render }